define('Custom404.EntryPoint', [
  'custom_error_management_page_not_found.tpl'
], function (
  Template
) {
  'use strict';

  return {
    mountToApp: function mountToApp(container) {
      var layout = container.getComponent('Layout');
      var environment = container.getComponent('Environment');
      var config = environment && environment.getConfig('Custom404');

      if(layout) {
        if(config && config.enable) {
          try {
            var ErrorManagementPageNotFoundView = require('ErrorManagement.PageNotFound.View');
            _.extend(ErrorManagementPageNotFoundView.prototype, {
              template: Template
            });

            layout.addToViewContextDefinition('ErrorManagement.PageNotFound.View', 'custom404content', 'string', function () {
              return config.content;
            });
          } catch (e) {
            console.log(e);
          }
        }
      }

    }
  };
});
